import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    userPhoneNumber: null,
    referralPhoneNumber: null,
    details: {},
    error: null,
    isFetchingDetails: false,
    isSSR: false
};

export const setUserPhoneNumber = (state = INITIAL_STATE, { userPhoneNumber }) => {
    return { ...state, userPhoneNumber};
};

export const activateReferral = (state = INITIAL_STATE) => {
    return { ...state, isFetchingDetails: true, error: null  };
};

export const activateReferralSuccess = (state = INITIAL_STATE, { details }) => {
    return { ...state, details, isFetchingDetails: false, error: null  };
};

export const activateReferralFailure = (state = INITIAL_STATE, { error }) => {
    return { ...state, error, isFetchingDetails: false };
};

export const HANDLERS = {
    [Types.SET_USER_PHONE_NUMBER]: setUserPhoneNumber,
    [Types.ACTIVATE_REFERRAL]: activateReferral,
    [Types.ACTIVATE_REFERRAL_SUCCESS]: activateReferralSuccess,
    [Types.ACTIVATE_REFERRAL_ERROR]: activateReferralFailure

};

export default createReducer(INITIAL_STATE, HANDLERS);
